import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';

export default function RefundPolicy() {
  return (
    <>
      <style>{`
        html, body {
          overflow-x: hidden !important;
        }
        .refund-container {
          max-width: 800px;
          margin: 0 auto;
          padding: 40px 20px;
          line-height: 1.6;
          color: #334155;
        }
        .refund-header {
          text-align: center;
          margin-bottom: 40px;
          padding-bottom: 20px;
          border-bottom: 2px solid #e5e7eb;
        }
        .refund-header h1 {
          color: #2563eb;
          font-size: 2.5rem;
          font-weight: 900;
          margin-bottom: 10px;
        }
        .refund-header p {
          color: #64748b;
          font-size: 1.1rem;
        }
        .refund-section {
          margin-bottom: 30px;
        }
        .refund-section h2 {
          color: #2563eb;
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 15px;
          border-left: 4px solid #2563eb;
          padding-left: 15px;
        }
        .refund-section h3 {
          color: #475569;
          font-size: 1.2rem;
          font-weight: 600;
          margin: 20px 0 10px 0;
        }
        .refund-section p {
          margin-bottom: 15px;
          text-align: justify;
        }
        .refund-section ul {
          margin: 15px 0;
          padding-left: 20px;
        }
        .refund-section li {
          margin-bottom: 8px;
        }
        .contact-info {
          background: #f8fafc;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          padding: 20px;
          margin: 20px 0;
        }
        .back-button {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #2563eb;
          color: white;
          padding: 12px 24px;
          border-radius: 8px;
          text-decoration: none;
          font-weight: 600;
          margin-bottom: 30px;
          transition: background-color 0.2s;
        }
        .back-button:hover {
          background: #1d4ed8;
        }
        .highlight-box {
          background: #eff6ff;
          border-left: 4px solid #2563eb;
          padding: 20px;
          margin: 20px 0;
          border-radius: 4px;
        }
        @media (max-width: 768px) {
          .refund-container {
            padding: 20px 15px;
          }
          .refund-header h1 {
            font-size: 2rem;
          }
          .refund-section h2 {
            font-size: 1.3rem;
          }
        }
      `}</style>
      
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(90deg, #f1f5fe 0%, #fff 100%)',
        padding: '20px 0'
      }}>
        <div className="refund-container">
          <a href="/" className="back-button">
            <i className="fas fa-arrow-left"></i>
            Nazad na početnu
          </a>
          
          <div className="refund-header">
            <h1>Politika Povraćaja Sredstava</h1>
            <p>CSV/Excel Konverter Pro</p>
            <p>Poslednje ažuriranje: {new Date().toLocaleDateString('sr-RS')}</p>
          </div>

          <div className="highlight-box">
            <p style={{fontWeight: 600, marginBottom: 8}}>
              <i className="fas fa-info-circle" style={{marginRight: 8, color: '#2563eb'}}></i>
              Važno: Molimo vas da pažljivo pročitate ovu politiku pre nego što napravite kupovinu.
            </p>
            <p>
              Naša politika povraćaja sredstava je dizajnirana da bude fer i transparentna za sve naše korisnike.
            </p>
          </div>

          <div className="refund-section">
            <h2>1. Pravo na Povraćaj</h2>
            <p>
              CSV/Excel Konverter Pro nudi povraćaj sredstava za plaćene pretplate u skladu sa zakonima 
              Republike Srbije i sledećim uslovima.
            </p>
          </div>

          <div className="refund-section">
            <h2>2. Period za Povraćaj</h2>
            <h3>2.1 Standardni Povraćaj</h3>
            <p>
              Imate pravo da zatražite pun povraćaj sredstava u roku od <strong>14 dana</strong> od datuma 
              kupovine pretplate, bez objašnjenja razloga. Ovo pravo se primenjuje na sve naše pretplate.
            </p>

            <h3>2.2 Povraćaj Nakon Probnog Perioda</h3>
            <p>
              Ako ste koristili besplatni probni period, period od 14 dana za povraćaj počinje od datuma 
              kada se probni period završio i počela je naplata.
            </p>
          </div>

          <div className="refund-section">
            <h2>3. Uslovi za Povraćaj</h2>
            <h3>3.1 Zahtev za Povraćaj</h3>
            <p>
              Da biste zatražili povraćaj, morate:
            </p>
            <ul>
              <li>Kontaktirati našu korisničku podršku na <a href="mailto:nemanja@lizzardsolutions.com" style={{color: '#2563eb'}}>nemanja@lizzardsolutions.com</a></li>
              <li>Navedite broj transakcije ili fakture</li>
              <li>Navedite razlog za povraćaj (opciono, ali pomaže nam da poboljšamo uslugu)</li>
              <li>Zahtev mora biti podnet u roku od 14 dana od datuma kupovine</li>
            </ul>

            <h3>3.2 Procesiranje Povraćaja</h3>
            <p>
              Nakon što primimo vaš zahtev za povraćaj, proverićemo vašu kupovinu i odgovoriti ćemo vam 
              u roku od 5 radnih dana. Ako je zahtev odobren, povraćaj će biti procesiran na isti način 
              plaćanja koji ste koristili, u roku od 10 radnih dana.
            </p>
          </div>

          <div className="refund-section">
            <h2>4. Slučajevi kada Povraćaj Nije Moguć</h2>
            <p>
              Povraćaj sredstava neće biti odobren u sledećim slučajevima:
            </p>
            <ul>
              <li>Zahtev je podnet nakon isteka 14-dnevnog roka</li>
              <li>Pretplata je već istekla ili je otkazana</li>
              <li>Korisnik je zloupotrebio uslugu ili prekršio Uslove korišćenja</li>
              <li>Korisnik je već koristio uslugu u značajnoj meri nakon kupovine</li>
              <li>Zahtev je podnet više puta za istu transakciju</li>
            </ul>
          </div>

          <div className="refund-section">
            <h2>5. Delimični Povraćaj</h2>
            <p>
              U slučaju da ste koristili uslugu značajno tokom perioda pretplate, možemo ponuditi 
              delimični povraćaj koji odražava vrednost neiskorišćenih dana pretplate. Ovo će biti 
              razmotreno slučaj po slučaj.
            </p>
          </div>

          <div className="refund-section">
            <h2>6. Povraćaj za Godišnje Pretplate</h2>
            <p>
              Za godišnje pretplate, imate pravo na pun povraćaj u roku od 14 dana. Nakon tog perioda, 
              možemo razmotriti delimični povraćaj na osnovu preostalih meseci pretplate, uz odbitak 
              administrativnih troškova.
            </p>
          </div>

          <div className="refund-section">
            <h2>7. Povraćaj za Mesečne Pretplate</h2>
            <p>
              Za mesečne pretplate, standardni period od 14 dana se primenjuje. Nakon isteka tog perioda, 
              pretplata se može otkazati bez obaveze za buduće naplate, ali povraćaj za tekući mesec 
              nije moguć.
            </p>
          </div>

          <div className="refund-section">
            <h2>8. Način Povraćaja</h2>
            <p>
              Povraćaj će biti izvršen na isti način plaćanja koji ste koristili za originalnu kupovinu:
            </p>
            <ul>
              <li>Kreditne/debitne kartice: Povraćaj će se pojaviti na vašem računu u roku od 10 radnih dana</li>
              <li>Bankovni transfer: Povraćaj će biti procesiran u roku od 10 radnih dana</li>
              <li>Druge metode plaćanja: Povraćaj će biti procesiran prema pravilima odgovarajućeg procesora plaćanja</li>
            </ul>
            <p>
              <strong>Napomena:</strong> Vreme potrebno da se povraćaj pojavi na vašem računu može varirati 
              zavisno od vaše banke ili procesora plaćanja.
            </p>
          </div>

          <div className="refund-section">
            <h2>9. Otkazivanje Pretplate</h2>
            <p>
              Otkazivanje pretplate ne garantuje automatski povraćaj sredstava. Ako otkažete pretplatu:
            </p>
            <ul>
              <li>Vaša pretplata će ostati aktivna do kraja tekućeg fakturnog perioda</li>
              <li>Nećete biti naplaćeni za buduće periode</li>
              <li>Povraćaj za tekući period je moguć samo ako je zahtev podnet u roku od 14 dana od kupovine</li>
            </ul>
          </div>

          <div className="refund-section">
            <h2>10. Sporovi i Rešavanje</h2>
            <p>
              Ako niste zadovoljni našom odlukom o povraćaju, možete:
            </p>
            <ul>
              <li>Kontaktirati našu korisničku podršku za dodatno razmatranje</li>
              <li>Podneti pritužbu nadležnom organu za zaštitu potrošača</li>
              <li>Tražiti posredovanje ili arbitražu u skladu sa zakonima Republike Srbije</li>
            </ul>
          </div>

          <div className="refund-section">
            <h2>11. Promene u Politici</h2>
            <p>
              Zadržavamo pravo da u bilo kom trenutku izmenimo ovu Politiku povraćaja. O svim značajnim 
              promenama obavestićemo vas putem email-a ili kroz našu aplikaciju. Promene će se primenjivati 
              na sve nove kupovine nakon datuma promene.
            </p>
          </div>

          <div className="refund-section">
            <h2>12. Kontakt</h2>
            <div className="contact-info">
              <p><strong>Za sva pitanja o povraćaju sredstava:</strong></p>
              <p>Email: <a href="mailto:nemanja@lizzardsolutions.com" style={{color: '#2563eb'}}>nemanja@lizzardsolutions.com</a></p>
              <p style={{marginTop: 15, fontSize: '0.9rem', color: '#64748b'}}>
                <strong>Radno vreme podrške:</strong> Ponedeljak - Petak, 9:00 - 17:00 CET
              </p>
            </div>
          </div>

          <div className="highlight-box" style={{marginTop: 30}}>
            <h3 style={{color: '#2563eb', marginBottom: 10}}>
              <i className="fas fa-lightbulb" style={{marginRight: 8}}></i>
              Savet
            </h3>
            <p>
              Pre nego što zatražite povraćaj, molimo vas da kontaktirate našu korisničku podršku. 
              Često možemo rešiti probleme koje imate i pomoći vam da maksimalno iskoristite našu uslugu.
            </p>
          </div>

          <div style={{
            marginTop: 40,
            padding: 20,
            background: '#f8fafc',
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            textAlign: 'center',
            color: '#64748b'
          }}>
            <p>&copy; {new Date().getFullYear()} CSV/Excel Konverter Pro. Sva prava zadržana.</p>
          </div>
        </div>
      </div>
    </>
  );
}

